import { MetaForm } from '@softline/dynamic';

export const ticketQueryMeta : MetaForm<any> = {
  id: {
    type: 'number',
    label: 'ID',
    format: 'NUMBER.DECIMAL',
    required: true,
    minimum: 1,
    maximum: 10,
  },
  name: {
    type: 'string',
  },
  serviceLevelAgreement: {
    type: 'object',
    object: {
      id: {
        type: 'number',
        format: 'NUMBER.DECIMAL'
      },
      name: {
        type: 'string',
      },
      description: {
        type: 'string',
      },
      area: {
        type: 'string',
      },
      urgency: {
        type: 'string',
      }
    }
  }
}
